//=================================================
//    summary: DCP Assignment 編輯頁面 -- Hook
//
//    remarks: 000 Tim 2020/12/20 Create
//             001 Tim 2021/12/23 加入 PaintedMe流程
//================================================
import React, { useState, useEffect, useRef } from 'react'
import cssAssignEdit from './AssignEdit.module.scss'
import './AssignEdit.css'

// import LoadingMask from '../../Windows/LoadingMask'
// import AlertWindow from '../../Windows/AlertWindow'
import {LoadingMask, AlertWindow, GlobalLibs, NetworkLibs, PackageVariablesLibs} from 'bc-react-package'

import TextField from '@material-ui/core/TextField'


// #region State Member Variables
let mstrStateMessage = ""
let mstrStateStartDate = ""
let mstrStateDueDate = ""
// #endregion State Member Variables

// #region Member Variables
let mblnInitialized = false

let marrDataProcess = []
let mobjCallParam = null

let mobjClassAssignmentDetail = null
let marrClassMemberData = []
let marrStudentListData = []
// let mdatStartMin = null
// let mdatDueMin = null
let mblnIsUpdate = false
// #endregion Member Variables

// #region Enumeration
const DataProcessEnum = {
    "GetClassNewAssignmentDetail": 0,
    "GetClassMemberDataList": 1
}
// #endregion Enumeration

// #region Const
const MAX_MESSAGE_CHARACHERS = 300 // Textarea最大的數字限制
// #endregion Const

const COMP_NAME = "AssignEdit"

function AssignEdit(props)
{
    console.log(COMP_NAME + ".Begin: ", props)

    // "props.Arguments": {
    //     "AssignmentSource": marrAssignmentSource[AssignmentIndex]
    // }

    // #region Init State
    const [updateDataTime, setUpdateDataTime] = useState(0)
    const [isSelectAll, setIsSelectAll] = useState(false)
    const [message, setMessage] = useState("")
    const [startDate, setStartDate] = useState("")
    const [dueDate, setDueDate] = useState("")
    
    const [showLoadingMask, setShowLoadingMask] = useState(false)
    const [loadingMaskMessage, setLoadingMaskMessage] = useState("")
    const [showAlert, setShowAlert] = useState(false)
    const [alertObject, setAlertObject] = useState(null)
    // #endregion Init State

    // #region Init Function Ref
    let mrefPaintedMe = useRef(null)
    
    mrefPaintedMe.current = PaintedMe
    // #endregion Init Function Ref

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + " Init variable")

        mblnInitialized = true
        mblnIsUpdate = false

        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)
    } // end of if (!mblnInitialized)
    // #endregion First Launch

    // Update message
    useEffect(() => {
        mstrStateMessage = message
    }, [message])

    // Update startDate
    useEffect(() => {
        mstrStateStartDate = startDate
    }, [startDate])

    // Update dueDate
    useEffect(() => {
        mstrStateDueDate = dueDate
    }, [dueDate])

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")
        
        mrefPaintedMe.current()

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")
            mblnInitialized = false
            mblnIsUpdate = false
            setUpdateDataTime(0)
        }
    }, [props.AssignmentSource])


    // #region OnTapHandler
    /*===========================================
    summary: 點選 返回 按鈕
    remarks: 000 Tim 2021/12/20 Create
    ===========================================*/
    function BackOnTapHandler()
    {
        console.log(COMP_NAME +  ".BackOnTapHandler")

        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let objCallbackData = {
            "Action": "CloseShowAssignEdit",
            "IsUpdate": mblnIsUpdate
        }
        props.CallbackRef(objCallbackData)
    } // end of BackOnTapHandler

    /*===========================================
    summary: 點選 SelectAll
    remarks: 000 Tim 2021/12/20 Create
    ===========================================*/
    function SelectAllOnTapHandler(StateIsSelectAll)
    {
        console.log(COMP_NAME +  ".SelectAllOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let blnIsSelectAll = !StateIsSelectAll
        let intIndex = 0;
        let intCount = marrStudentListData.length

        //  == 整理需要處理的變數 BEGIN ==
        for (intIndex = 0; intIndex < intCount; intIndex++)
        {
            marrStudentListData[intIndex].IsCheck = blnIsSelectAll
        }

        setIsSelectAll(blnIsSelectAll)
        setUpdateDataTime(new Date().getTime())
    } // end of SelectAllOnTapHandler

    /*===========================================
    summary: 點選 學生元件
    remarks: 000 Tim 2021/12/20 Create
    ===========================================*/
    function StudentUnitOnTapHandler(StudentIndex)
    {
        console.log(COMP_NAME +  ".StudentUnitOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        marrStudentListData[StudentIndex].IsCheck = !marrStudentListData[StudentIndex].IsCheck

        // 檢查 是否為 Select All
        let intIndex = 0
        let intCount = marrStudentListData.length
        let blnIsSelectAll = true

        while ((blnIsSelectAll) && (intIndex < intCount))
        {
            if (!marrStudentListData[intIndex].IsCheck)
            {
                blnIsSelectAll = false
            }

            intIndex++
        } // end of while

        setIsSelectAll(blnIsSelectAll)
        setUpdateDataTime(new Date().getTime())
    } // end of StudentUnitOnTapHandler

    /*===========================================
    summary: 點選 Submit
    remarks: 000 Tim 2021/12/20 Create
    ===========================================*/
    function SubmitOnTapHandler()
    {
        console.log(COMP_NAME +  ".SubmitOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        SubmitEditAssignmentData()
    } // end of SubmitOnTapHandler
    // #endregion OnTapHandler

    // #region Other EventHandler
    /*===========================================
    summary: Message 改變 事件
    remarks: 000 Tim 2021/12/20 Create
    ===========================================*/
    function MessageChangeHandler(e)
    {
        // console.log(COMP_NAME + ".MessageChangeHandler: e.target.value:", e.target.value)
        setMessage(e.target.value)
    } // end of MessageChangeHandler

    /*===========================================
    summary: Start Date 改變 事件
    remarks: 000 Tim 2021/12/20 Create
             001 Tim 2022/03/04 將日期文字 - 轉成 /
    ===========================================*/
    function StartDateOnChangeEventHandler(e)
    {
        // console.log(COMP_NAME + ".StartDateOnChangeEventHandler: e.target.value:", e.target.value)
        let strStartDate = e.target.value

        // 以台灣時間來說 +8
        // 2022/03/03  -> 經過 new Date 會是 2022/03/03 00:00:00  
        // 輸入的日期文字 會當作 Local Time
        // 2022-03-03  -> 經過 new Date 會是 2022/03/03 08:00:00  
        // 輸入的日期文字 會當作 +0 Time

        // 開始時間
        let datStartLocal = new Date(strStartDate.replace(/-/g, '/'))
        datStartLocal.setHours(0, 0, 0, 0)
        console.log(COMP_NAME + ".StartDateOnChangeEventHandler datStartLocal: ", datStartLocal)

        // 截止時間
        let datDueLocal = new Date(mstrStateDueDate.replace(/-/g, '/'))
        datDueLocal.setHours(23, 59, 59, 0)
        console.log(COMP_NAME + ".StartDateOnChangeEventHandler datDueLocal: ", datDueLocal)

        setStartDate(strStartDate)

        // check 截止日期 需要大於 開始日期
        if (datDueLocal.valueOf() < datStartLocal.valueOf())
        {
            setDueDate(strStartDate)
        }
    } // end of StartDateOnChangeEventHandler

    /*===========================================
    summary: Due Date 改變 事件
    remarks: 000 Tim 2021/12/20 Create
    ===========================================*/
    function DueDateOnChangeEventHandler(e)
    {
        // console.log(COMP_NAME + ".DueDateOnChangeEventHandler: e.target.value:", e.target.value)
        setDueDate(e.target.value)
    } // end of DueDateOnChangeEventHandler
    // #endregion Other EventHandler
    
    // #region LoadingMask and Alert Functions
    /*===========================================
    summary: 開啟 讀取中 效果
    remarks: 000 Tim 2021/12/20 Create
    ===========================================*/
    function OpenLoadingMask(LoadingMsg)
    {
        console.log(COMP_NAME + ".OpenLoadingMask")
        setShowLoadingMask(true)
        setLoadingMaskMessage(LoadingMsg)
    } // end of OpenLoadingMask

    /*===========================================
    summary: 關閉 讀取中 效果
    remarks: 000 Tim 2021/12/20 Create
    ===========================================*/
    function CloseLoadingMask()
    {
        console.log(COMP_NAME + ".CloseLoadingMask")
        setShowLoadingMask(false)
        setLoadingMaskMessage("")
    } // end of CloseLoadingMask

    /*===========================================
    summary: 顯示 提示視窗
    remarks: 000 Tim 2021/12/20 Create
    ===========================================*/
    function ShowAlert(AlertObject)
    {
        setAlertObject(AlertObject)
        setShowAlert(true)
    } // end of ShowAlert

    /*===========================================
    summary: 關閉 提示視窗
    remarks: 000 Tim 2021/12/20 Create
    ===========================================*/
    function HideAlert()
    {
        setAlertObject(null)
        setShowAlert(false)
    } // end of HideAlert
    // #endregion LoadingMask and Alert Functions

    // #region Other Functions
    /*===========================================
    summary: componentDidMount 程式進入 處理Props資料
    remarks: 000 Tim 2021/12/23 Create
    ===========================================*/
    function PaintedMe()
    {
        console.log(COMP_NAME + ".PaintedMe")

        // 到後端 取得 資料
        GetDataProcessBegin()
    } // end of PaintedMe

    /*===========================================
    summary: 取得 後端資料 流程 開始 
    remarks: 000 Tim 2021/12/20 Create
    ===========================================*/
    function GetDataProcessBegin ()
    {
        console.log(COMP_NAME + ".GetDataProcessBegin")

        marrDataProcess = []

        // 讀取資料
        // 1. this.GetClassNewAssignmentDetail()
        // 2. this.GetClassMemberDataList();
        marrDataProcess.push(DataProcessEnum.GetClassNewAssignmentDetail)
        marrDataProcess.push(DataProcessEnum.GetClassMemberDataList)
        
        ExecuteDataProcess()
    } // end of GetDataProcessBegin

    /*===========================================
    summary: 取得 後端資料 流程 結束
    remarks: 000 Tim 2021/12/20 Create
    ===========================================*/
    function GetDataProcessEnd ()
    {
        console.log(COMP_NAME + ".GetDataProcessEnd");

        setMessage(mobjClassAssignmentDetail.Message)
        InitClassAssignmentAndMemberData()
    } // end of GetDataProcessEnd

    /*===========================================
    summary: 取得 後端資料 流程 開始 
    remarks: 000 Tim 2021/12/20 Create
    ===========================================*/
    function ExecuteDataProcess ()
    {
        console.log(COMP_NAME + ".ExecuteDataProcess")

        if (marrDataProcess.length > 0)
        {
            let intDataProcess = marrDataProcess[0]
            // 繼續執行讀取資料
            switch (intDataProcess)
            {
                case DataProcessEnum.GetClassNewAssignmentDetail:
                    mobjCallParam = {
                        "NewAssignmentID": props.Arguments.AssignmentSource.NewAssignmentID
                    }
                    GetClassNewAssignmentDetail()
                    break
                case DataProcessEnum.GetClassMemberDataList:
                    mobjCallParam = {
                        "ClassID": window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].ClassID,
                        "DataType": 1
                    }
                    GetClassMemberDataList()
                    break
                default:
                    break
            }

            // 移除 第一個 讀過的 流程
            marrDataProcess.shift()
        }
        else
        {
            // 結束
            GetDataProcessEnd()
        }
    } // end of ExecuteDataProcess

    /*===========================================
    summary: 初始化班級考卷詳細資料
    remarks: 000 Tim 2021/12/20 Create
    ===========================================*/
    function InitClassAssignmentAndMemberData()
    {
        let intIndex = 0;
        let intCount = marrClassMemberData.length
        let intIndex4Student = 0
        let intCount4Student = mobjClassAssignmentDetail.ScoreList.length
        var blnInitCheck = false

        let objMemberItem = null
        let arrStudentData4List = []

        //  == 整理需要處理的變數 BEGIN ==
        for (intIndex = 0; intIndex < intCount; intIndex++)
        {
            blnInitCheck = false
            intIndex4Student = 0
            while ((!blnInitCheck) && (intIndex4Student < intCount4Student))
            {
                if (parseInt(marrClassMemberData[intIndex].StudentAccID) === parseInt(mobjClassAssignmentDetail.ScoreList[intIndex4Student].StudentAccID))
                {
                    blnInitCheck = true
                }
                intIndex4Student++
            } // end of while

            objMemberItem = {
                "AccountID": marrClassMemberData[intIndex].StudentAccID,
                "Name": window.Globals.FormateDisplayName(marrClassMemberData[intIndex].FirstName, marrClassMemberData[intIndex].LastName, marrClassMemberData[intIndex].SchoolUserName),
                "IsCheck": false,
                "InitCheck": blnInitCheck
            }
            arrStudentData4List.push(objMemberItem)
        }

        marrStudentListData = arrStudentData4List
        //  == 整理需要處理的變數 END ==

        console.log(COMP_NAME + ".InitClassAssignmentAndMemberData marrStudentListData: ", marrStudentListData)

        // let datNowLocal = new Date()

        // Start Date
        let datStartLocal = mobjClassAssignmentDetail.StartDate.ToUTC()
        let strStartLocal = datStartLocal.FormateBCDisplayDate()
        console.log(COMP_NAME + ".InitClassAssignmentAndMemberData mobjClassAssignmentDetail.StartDate: ", mobjClassAssignmentDetail.StartDate)
        console.log(COMP_NAME + ".InitClassAssignmentAndMemberData datStartLocal: ", datStartLocal)
        console.log(COMP_NAME + ".InitClassAssignmentAndMemberData strStartLocal: ", strStartLocal)

        // Due Date
        let datDueLocal = mobjClassAssignmentDetail.DueDate.ToUTC()
        let strDueLocal = datDueLocal.FormateBCDisplayDate()
        console.log(COMP_NAME + ".InitClassAssignmentAndMemberData mobjClassAssignmentDetail.DueDate: ", mobjClassAssignmentDetail.DueDate)
        console.log(COMP_NAME + ".InitClassAssignmentAndMemberData datDueLocal: ", datDueLocal)
        console.log(COMP_NAME + ".InitClassAssignmentAndMemberData strDueLocal: ", strDueLocal)

        setStartDate(strStartLocal)
        setDueDate(strDueLocal)
        setUpdateDataTime(new Date().getTime())
    } // end of InitClassAssignmentAndMemberData

    /*===========================================
    summary: 傳送輸入表單資料 到後端 Json格式
    remarks: 000 Tim 2021/12/20 Create
    ===========================================*/
    function SubmitEditAssignmentData ()
    {
        console.log(COMP_NAME + ".SubmitEditAssignmentData");
        
        let objAlertObject = null

        let datStartLocal = null            // 從元件讀出的 開始時間
        let datDueLocal = null              // 從元件讀出的 截止時間
        let datOriginalStartLocal = null    // 原始 開始時間
        let datOriginalDueLocal = null      // 原始 截止時間

        let arrStudentList = []
        let intIndex4Student = 0
        let intCount4Student = marrStudentListData.length

        let objValidation = null
        let blnAlert = false

        // Validation Message
        objValidation = ValidationMessage()
        if (!objValidation.IsValidation)
        {
            blnAlert = true
        }

        // 取得學生選擇資料
        for (intIndex4Student = 0; intIndex4Student < intCount4Student; intIndex4Student++)
        {
            if (
                (marrStudentListData[intIndex4Student].IsCheck) &&
                (!marrStudentListData[intIndex4Student].InitCheck)
                )
            {
                arrStudentList.push(parseInt(marrStudentListData[intIndex4Student].AccountID))
            } // end of if (marrStudentListData[intIndex4Student].IsCheck)
        } // end of for (intIndex4Student = 0;

        // Validation Data
        objValidation = ValidationDate(arrStudentList)
        if (!objValidation.IsValidation)
        {
            blnAlert = true
        }
        else
        {
            datStartLocal = objValidation.StartLocal
            datDueLocal = objValidation.DueLocal
            datOriginalStartLocal = objValidation.OriginalStartLocal
            datOriginalDueLocal = objValidation.OriginalDueLocal
        }

        if (blnAlert)
        {
            objAlertObject = {
                Header: objValidation.AlertTitle,
                Body: objValidation.AlertMessage,
                CallbackRef: null,
                Buttons: [
                    {
                        Text: PackageVariablesLibs.UISettings.BTN_OK,
                        AutoFocus: true
                    }
                ]
            }

            ShowAlert(objAlertObject)
        }
        else
        {
            // 初步檢查通過了

            // check Data 是否有被修改
            if (
                (mstrStateMessage.trim() !== mobjClassAssignmentDetail.Message.trim()) || 
                (datOriginalStartLocal.valueOf() !== datStartLocal.valueOf()) ||
                (datOriginalDueLocal.valueOf() !== datDueLocal.valueOf()) ||
                (arrStudentList.length > 0)
                )
            {
                console.log("need send to backend!")

                mobjCallParam = {
                    "NewAssignmentID": props.Arguments.AssignmentSource.NewAssignmentID,
                    "ClassID": window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].ClassID,
                    "BookCategoryID": props.Arguments.AssignmentSource.BookCategoryID,
                    "Name": props.Arguments.AssignmentSource.Name,
                    "Message": mstrStateMessage.trim(),
                    "StartDate": datStartLocal.ToBCUTCString(),
                    "DueDate": datDueLocal.ToBCUTCString(),
                    "StudentList": arrStudentList,
                    "AssigneeList": "",
                    "LessonID": props.Arguments.AssignmentSource.LessonID,
                    "LUCatSeqNo": props.Arguments.AssignmentSource.LUCatSeqNo,
                    "SectionType": parseInt(props.Arguments.AssignmentSource.SectionType),
                    "Dirty": false
                }

                if (mobjCallParam.StudentList.length > 0)
                {
                    mobjCallParam.AssigneeList = JSON.stringify(mobjCallParam.StudentList)
                }
        
                console.log("SubmitEditAssignmentData mobjCallParam: ", mobjCallParam)
                EditNewAssignment()
            }
            else
            {
                console.log("need not send to backend!");                
                objAlertObject = {
                    Header: "",
                    Body: window.gAppUI.MSG_SubmitSuccess,
                    CallbackRef: null,
                    Buttons: [
                        {
                            Text: PackageVariablesLibs.UISettings.BTN_OK,
                            AutoFocus: true
                        }
                    ]
                }
    
                ShowAlert(objAlertObject)
            }
        }

        console.log("SubmitEditAssignmentData END")
    } // end of SubmitEditAssignmentData

    /*===========================================
    summary: 檢查 Message 格式
    remarks: 000 Tim 2021/12/20 Create
    ===========================================*/
    function ValidationMessage() 
    {
        console.log(COMP_NAME + ".ValidationMessage")
        let objValidation = {
            "IsValidation": true,
            "AlertTitle": "",
            "AlertMessage": ""
        }

        if (mstrStateMessage.trim() === "")
        {
            objValidation.IsValidation = false
            objValidation.AlertTitle = ""
            objValidation.AlertMessage = window.gAppUI.ERR_InputAssignMessage
        }

        return objValidation
    } // end of ValidationMessage

    /*===========================================
    summary: 檢查 日期 格式
    remarks: 000 Tim 2021/12/20 Create
             001 Tim 2022/01/22 調整 檢查規則
             002 Tim 2022/01/24 調整 選DueDateEarlyToday時，應該要跳"Due Date cannot be erlier than Today."
                                區分的case
                                如果編輯考卷，加新學生，但duedate早於今天，在顯示： "Please change the due date before assigning it to a new student."
             003 Tim 2022/03/04 將日期文字 - 轉成 /
                                // 以台灣時間來說 +8
                                // 2022/03/03  -> 經過 new Date 會是 2022/03/03 00:00:00  
                                // 輸入的日期文字 會當作 Local Time
                                // 2022-03-03  -> 經過 new Date 會是 2022/03/03 08:00:00  
                                // 輸入的日期文字 會當作 +0 Time
    ===========================================*/
    function ValidationDate(StudentList) 
    {
        console.log(COMP_NAME + ".ValidationDate")
        let objValidation = {
            "IsValidation": true,
            "AlertTitle": "",
            "AlertMessage": "",
            "StartLocal": null,       // utc輸入開始時間 檢查時間 是否小於現在時間
            "DueLocal": null,         // utc輸入截止時間 檢查時間 是否小於現在時間 
            "OriginalStartLocal": null,      
            "OriginalDueLocal": null
        }

        let datStartLocal = null            // utc輸入開始時間 檢查時間 是否小於現在時間
        let datDueLocal = null              // utc輸入截止時間 檢查時間 是否小於現在時間
        let datOriginalStartLocal = null    // 原始 開始時間
        let datOriginalDueLocal = null      // 原始 截止時間
        let datNowStartLocal = null         // 目前時間-開始
        let datNowDueLocal = null           // 目前時間-截止

        // 比較日期
        // 開始時間
        datStartLocal = new Date(mstrStateStartDate.replace(/-/g, '/'))
        datStartLocal.setHours(0, 0, 0, 0)
        datOriginalStartLocal = mobjClassAssignmentDetail.StartDate.ToUTC()
        datOriginalStartLocal.setHours(0, 0, 0, 0)
        console.log(COMP_NAME + ".ValidationDate datStartLocal: ", datStartLocal)
        console.log(COMP_NAME + ".ValidationDate datOriginalStartLocal: ", datOriginalStartLocal)

        // 截止時間
        datDueLocal = new Date(mstrStateDueDate.replace(/-/g, '/'))
        datDueLocal.setHours(23, 59, 59, 0)
        datOriginalDueLocal = mobjClassAssignmentDetail.DueDate.ToUTC()
        datOriginalDueLocal.setHours(23, 59, 59, 0)
        console.log(COMP_NAME + ".ValidationDate datDueLocal: ", datDueLocal)
        console.log(COMP_NAME + ".ValidationDate datOriginalDueLocal: ", datOriginalDueLocal)

        // 目前時間-開始
        datNowStartLocal = new Date()
        datNowStartLocal.setHours(0, 0, 0, 0)

        // 目前時間-截止
        datNowDueLocal = new Date()
        datNowDueLocal.setHours(23, 59, 59, 0)

        if (
            (datOriginalStartLocal.valueOf() !== datStartLocal.valueOf()) &&
            (datStartLocal.valueOf() < datNowStartLocal.valueOf())
            )
        {
            // 如果修改了開始日期，則開始日期不能早於今天
            // ERR_StartDateEarlyToday
            console.log(COMP_NAME + ".SubmitEditAssignmentData datStartLocal", datStartLocal)

            objValidation.IsValidation = false
            objValidation.AlertTitle = ""
            objValidation.AlertMessage = window.gAppUI.ERR_StartDateEarlyToday
        }
        else if (
            (datOriginalDueLocal.valueOf() !== datDueLocal.valueOf()) &&
            (datDueLocal.valueOf() < datNowDueLocal.valueOf())
            )
        {
            // 如果修改了截止日期，則截止日期不能早於今天
            // ERR_DueDateEarly
            objValidation.IsValidation = false
            objValidation.AlertTitle = ""
            objValidation.AlertMessage = window.gAppUI.ERR_DueDateEarlyToday
        }
        else if (
            (StudentList.length > 0) &&
            (datDueLocal.valueOf() < datNowDueLocal.valueOf())
            )
        {
            // 如果編輯考卷，加新學生，但duedate早於今天
            // ERR_ChangeNewStudentDueDateEarlyToday
            objValidation.IsValidation = false
            objValidation.AlertTitle = ""
            objValidation.AlertMessage = window.gAppUI.ERR_ChangeNewStudentDueDateEarlyToday
        }
        else if (
            (datOriginalDueLocal.valueOf() !== datDueLocal.valueOf()) &&
            (datDueLocal.valueOf() < datStartLocal.valueOf())
            )
        {
            // 如果修改了截止日期，則截止日期不能早於開始日期
            // ERR_DueDateEarlyStartDate
            objValidation.IsValidation = false
            objValidation.AlertTitle = ""
            objValidation.AlertMessage = window.gAppUI.ERR_DueDateEarlyStartDate
        }
        else
        {
            objValidation.StartLocal = datStartLocal
            objValidation.DueLocal = datDueLocal
            objValidation.OriginalStartLocal = datOriginalStartLocal
            objValidation.OriginalDueLocal = datOriginalDueLocal
        }

        return objValidation
    } // end of ValidationDate
    // #endregion Other Functions

    // #region Get ClassName
    /*===========================================
    summary: 取得 選擇全部學生 Cls
    remarks: 000 Tim 2021/12/20 Create
    ===========================================*/
    function GetSelectAllIconCls(StateIsSelectAll) 
    {
        let objCls = cssAssignEdit.divSelectAllIcon

        if (StateIsSelectAll)
        {
            objCls = cssAssignEdit.divSelectAllSelectedIcon
        }

        return objCls
    } // end of GetSelectAllIconCls

    /*===========================================
    summary: 取得 學生元件 Cls
    remarks: 000 Tim 2021/12/20 Create
    ===========================================*/
    function GetStudentUnitCls(IsCheck, InitCheck) 
    {
        let objCls = cssAssignEdit.divStudentUnit

        if (InitCheck)
        {
            objCls = cssAssignEdit.divStudentUnitInitSelected
        }
        else if (IsCheck)
        {
            objCls = cssAssignEdit.divStudentUnitSelected
        }

        return objCls
    } // end of GetStudentUnitCls

    /*===========================================
    summary: 取得 學生元件 Check圖示 Cls
    remarks: 000 Tim 2021/12/20 Create
    ===========================================*/
    function GetStudentUnitCheckCls(IsCheck, InitCheck) 
    {
        let objCls = cssAssignEdit.divStudentUnitCheckIcon

        if (
            (IsCheck) || 
            (InitCheck)
            )
        {
            objCls = cssAssignEdit.divStudentUnitCheckSelectedIcon
        }

        return objCls
    } // end of GetStudentUnitCheckCls

    /*===========================================
    summary: 取得 學生元件 Check圖示 Cls
    remarks: 000 Tim 2021/12/20 Create
    ===========================================*/
    function GetStudentUnitNameCls(IsCheck, InitCheck) 
    {
        let objCls = cssAssignEdit.divStudentUnitName

        if (
            (IsCheck) || 
            (InitCheck)
            )
        {
            objCls = cssAssignEdit.divStudentUnitNameSelected
        }

        return objCls
    } // end of GetStudentUnitNameCls
    // #endregion Get ClassName

    // #region Web Service After Process
    /*===========================================
    summary: 把修改完考卷內容回存後端後 的 流程
    remarks: 000 Tim 2021/12/20 Create
    ===========================================*/
    function EditNewAssignmentAfterProcess ()
    {   
        console.log(COMP_NAME + ".EditNewAssignmentAfterProcess")

        console.log("Finished Save Edit Assignment")

        let objAlertObject = {
            Header: "",
            Body: window.gAppUI.MSG_SubmitSuccess,
            CallbackRef: null,
            Buttons: [
                {
                    Text: PackageVariablesLibs.UISettings.BTN_OK,
                    AutoFocus: true
                }
            ]
        }
        ShowAlert(objAlertObject)

        mblnIsUpdate = true

        // 把資料 塞回 objClassAssignmentDetail
        mobjClassAssignmentDetail.Name = mobjCallParam.Name
        mobjClassAssignmentDetail.Message = mobjCallParam.Message
        mobjClassAssignmentDetail.StartDate = mobjCallParam.StartDate
        mobjClassAssignmentDetail.DueDate = mobjCallParam.DueDate

        let intIndex = 0
        var intCount = mobjCallParam.StudentList.length
        for(intIndex = 0; intIndex < intCount; intIndex++)
        {
            // 把資料 塞回 objClassAssignmentDetail.StudentList
            // console.log("StudentList", intIndex, mobjCallParam.StudentList[intIndex])
            mobjClassAssignmentDetail.ScoreList.push(
                {
                    "StudentAccID": mobjCallParam.StudentList[intIndex]
                }
            )
        }

        // 確認資料有修改
        mobjCallParam.Dirty = true
        InitClassAssignmentAndMemberData()

        mobjCallParam = null
    } // end of EditNewAssignmentAfterProcess

    /*===========================================
    summary: 取得 班級成員列表資料 完畢
    remarks: 000 Tim 2021/12/20 Create
    ===========================================*/
    function GetClassMemberDataListAfterProcess(ReturnData)
    {
        console.log(COMP_NAME + ".GetClassMemberDataListAfterProcess")

        marrClassMemberData = ReturnData
        mobjCallParam = null

        ExecuteDataProcess()
    } // end of GetClassMemberDataListAfterProcess

    /*===========================================
    summary: 取得考卷詳細資料 完畢
    remarks: 000 Tim 2021/12/20 Create
    ===========================================*/
    function GetClassNewAssignmentDetailAfterProcess(ReturnData)
    {
        console.log(COMP_NAME + ".GetClassNewAssignmentDetailAfterProcess")

        mobjClassAssignmentDetail = ReturnData
        mobjCallParam = null

        ExecuteDataProcess()
    } // end of GetClassNewAssignmentDetailAfterProcess
    // #endregion Web Service After Process

    // #region Web Service
    /*===========================================
    summary: 取得考卷詳細資料
    remarks: 000 Tim 2021/12/20 Create
    ===========================================*/
    function GetClassNewAssignmentDetail()
    {        
        let objRetryFuncRef = GetClassNewAssignmentDetail
        
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = GetClassNewAssignmentDetailCallback
            // let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_WEB_GATEWAY
            
            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_GetClassNewAssignmentDetail)

            let objCallData = {
                "Func": "GetClassNewAssignmentDetail",
                "NewAssignmentID": mobjCallParam.NewAssignmentID
            }
            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        }
    } // end of GetClassNewAssignmentDetail

    /*===========================================
    summary: 取得考卷詳細資料 Callback
    remarks: 000 Tim 2021/12/20 Create
    ===========================================*/
    function GetClassNewAssignmentDetailCallback(Return)
    {        
        // Close Loading mask
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_GetClassNewAssignmentDetail_No
        let strErrorTitle = window.gAppUI.ERR_GetClassNewAssignmentDetail_Title
        let strErrMsg = window.gAppUI.ERR_GetClassNewAssignmentDetail_Msg
        // end of customize
        
        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break;
                default:
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            }

            console.log("GetClassNewAssignmentDetailCallback: ErrNo: ", Return.ErrNo)
            console.log("GetClassNewAssignmentDetailCallback: CalledErrNo: ", Return.CalledErrNo)
        }
        else
        {
            console.log("GetClassNewAssignmentDetailCallback Return.Data: ", Return.Data)

            GetClassNewAssignmentDetailAfterProcess(Return.Data)
        }
    } // end of GetClassNewAssignmentDetailCallback

    /*===========================================
    summary: 取得班級成員列表資料
    remarks: 000 Tim 2021/12/20 Create
    ===========================================*/
    function GetClassMemberDataList()
    {        
        let objRetryFuncRef = GetClassMemberDataList
        
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = GetClassMemberDataListCallback
            // let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_WEB_GATEWAY
            
            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_GetClassMemberDataList)

            let objCallData = {
                "Func": "GetClassMemberDataList",
                "ClassID": mobjCallParam.ClassID,
                "DataType": mobjCallParam.DataType
            }
            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        }
    } // end of GetClassMemberDataList

    /*===========================================
    summary: 取得班級成員列表資料 Callback
    remarks: 000 Tim 2021/12/20 Create
    ===========================================*/
    function GetClassMemberDataListCallback(Return)
    {        
        // Close Loading mask
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_GetClassMemberDataList_No
        let strErrorTitle = window.gAppUI.ERR_GetClassMemberDataList_Title
        let strErrMsg = window.gAppUI.ERR_GetClassMemberDataList_Msg
        // end of customize
        
        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break;
                default:
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            }

            console.log("GetClassMemberDataListCallback: ErrNo: ", Return.ErrNo)
            console.log("GetClassMemberDataListCallback: CalledErrNo: ", Return.CalledErrNo)
        }
        else
        {
            console.log("GetClassMemberDataListCallback Return.Data: ", Return.Data)

            GetClassMemberDataListAfterProcess(Return.Data)
        }
    } // end of GetClassMemberDataListCallback

    /*===========================================
    summary: 把修改完考卷內容回存後端
    remarks: 000 Tim 2021/12/20 Create
    ===========================================*/
    function EditNewAssignment()
    {        
        let objRetryFuncRef = EditNewAssignment
        
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = EditNewAssignmentCallback
            // let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_WEB_GATEWAY
            
            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_EditAssignment)

            let objCallData = {
                "Func": "EditNewAssignment",
                "NewAssignmentID": mobjCallParam.NewAssignmentID,
                "ClassID": mobjCallParam.ClassID,
                "BookCategoryID": mobjCallParam.BookCategoryID,
                "LessonID": mobjCallParam.LessonID,
                "LUCatSeqNo": mobjCallParam.LUCatSeqNo,
                "AssignName": mobjCallParam.Name,
                "Message": mobjCallParam.Message,
                "StartDate": mobjCallParam.StartDate,
                "DueDate": mobjCallParam.DueDate,
                "SectionType": mobjCallParam.SectionType,
                "AssigneeList": mobjCallParam.AssigneeList
            }

            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        }
    } // end of EditNewAssignment

    /*===========================================
    summary: 把修改完考卷內容回存後端 Callback
    remarks: 000 Tim 2021/12/20 Create
    ===========================================*/
    function EditNewAssignmentCallback(Return)
    {        
        // Close Loading mask
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_EditAssignment_No
        let strErrorTitle = window.gAppUI.ERR_EditAssignment_Title
        let strErrMsg = window.gAppUI.ERR_EditAssignment_Msg
        // end of customize
        
        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break;
                default:
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            }

            console.log("EditNewAssignmentCallback: ErrNo: ", Return.ErrNo)
            console.log("EditNewAssignmentCallback: CalledErrNo: ", Return.CalledErrNo)
        }
        else
        {
            console.log("EditNewAssignmentCallback Return.Data: ", Return.Data)

            EditNewAssignmentAfterProcess()
        }
    } // end of EditNewAssignmentCallback
    // #endsregion Web Service

    // #region Render元件
    /*===========================================
    summary: Submit Button 顯示Component
    remarks: 000 Tim 2021/12/20 Create
    ===========================================*/
    function ComponentStudentUnitContent( {StudentData} )
    {        
        return (
            <>
                <div className={GetStudentUnitCheckCls(StudentData.IsCheck, StudentData.InitCheck)}/>
                <div className={GetStudentUnitNameCls(StudentData.IsCheck, StudentData.InitCheck)}>
                    {StudentData.Name}
                </div>
            </>
        )
    } // end of ComponentStudentUnitContent

    /*===========================================
    summary: Submit Button 顯示Component
    remarks: 000 Tim 2021/12/20 Create
    ===========================================*/
    function ComponentSubmitButton()
    {        
        return (
            <div className={cssAssignEdit.btnSubmit} onClick={() => SubmitOnTapHandler()}>
                {window.gAppUI.BTN_Submit}
            </div>
        )
    } // end of ComponentSubmitButton

    /*===========================================
    summary: Select All Button 顯示Component
    remarks: 000 Tim 2021/12/20 Create
    ===========================================*/
    function ComponentSelectAllButton( {StateIsSelectAll} )
    {        
        return (
            <div className={cssAssignEdit.btnSelectAll} onClick={() => SelectAllOnTapHandler(StateIsSelectAll)}>
                <div className={GetSelectAllIconCls(StateIsSelectAll)}/>
                <div className={cssAssignEdit.divSelectAllText}>
                    {window.gAppUI.LBL_SelectAll}
                </div>
            </div>
        )
    } // end of ComponentSelectAllButton

    /*===========================================
    summary: Date Separator 顯示Component
    remarks: 000 Tim 2021/12/20 Create
    ===========================================*/
    function ComponentDateSeparator()
    {        
        return (
            <div className={cssAssignEdit.divSeparator}>
                ............
            </div>
        )
    } // end of ComponentDateSeparator 

    /*===========================================
    summary: Date Title 顯示Component
    remarks: 000 Tim 2021/12/20 Create
    ===========================================*/
    function ComponentDateTitle( {Title} ) 
    {        
        return (
            <div className={cssAssignEdit.divDateTitleRow}>
                <div className={cssAssignEdit.divDateIcon}/>
                <div className={cssAssignEdit.divDateTitle}>
                    {Title}
                </div>
            </div>
        )
    } // end of ComponentDateTitle 

    /*===========================================
    summary: Message Title 顯示Component
    remarks: 000 Tim 2021/12/20 Create
    ===========================================*/
    function ComponentMessageTitle() 
    {   
        return(
            <div className={cssAssignEdit.divMessageTitle}>
                {window.gAppUI.LBL_Message}
            </div>
        )
    } // end of ComponentMessageTitle

    /*===========================================
    summary: Title 顯示Component
    remarks: 000 Tim 2021/12/20 Create
    ===========================================*/
    function ComponentTitle( {StateUpdateDataTime} ) 
    {   
        if (StateUpdateDataTime > 0)
        {
            return(
                <div className={cssAssignEdit.divTitle}>
                    {window.gAppUI.LBL_EditBulletin}
                </div>
            )
        }
        else
        {
            return ""
        }
    } // end of ComponentTitle

    /*===========================================
    summary: 離開按鈕 顯示Component
    remarks: 000 Tim 2021/12/20 Create
    ===========================================*/
    function ComponentBackButton() 
    {   
        return(
            <div className={cssAssignEdit.btnBack} onClick={() => BackOnTapHandler()}/>
        )
    } // end of ComponentBackButton
    // #endregion Render元件

    // #region Render
    /*===========================================
    summary: Render 學生列表
    remarks: 000 Tim 2021/12/20 Create
    ===========================================*/
    function RenderStudentListWrapper()
    {
        return(
            <div className={cssAssignEdit.divStudentArea}>
                {marrStudentListData.map((StudentData, StudentIndex) =>
                    <div key={StudentIndex} className={GetStudentUnitCls(StudentData.IsCheck, StudentData.InitCheck)} 
                            onClick={() => StudentUnitOnTapHandler(StudentIndex)}>
                        <ComponentStudentUnitContent StudentData={StudentData} />
                    </div>
                )}
            </div>
        )
    } // end of RenderStudentListWrapper

    /*===========================================
    summary: Render Due Date Area 日期選單
    remarks: 000 Tim 2021/12/20 Create
    ===========================================*/
    function RenderDueDateAreaWrapper()
    {
        let strTextFieldID = "txtDueDate"
        if (window.gSession.App.InApp)
        {
            strTextFieldID = "txtDueDateApp"
        }

        return(
            <div className={cssAssignEdit.divDateMain}>
                <ComponentDateTitle Title={window.gAppUI.LBL_DueDate} />
                
                <div className={cssAssignEdit.btnDate}>
                    <TextField id={strTextFieldID} 
                        type="date" value={dueDate}
                        onChange={(event) => DueDateOnChangeEventHandler(event)}/>
                </div>
            </div>
        )
    } // end of RenderDueDateAreaWrapper

    /*===========================================
    summary: Render Start Date Area 日期選單
    remarks: 000 Tim 2021/12/20 Create
    ===========================================*/
    function RenderStartDateAreaWrapper()
    {
        let strTextFieldID = "txtStartDate"
        if (window.gSession.App.InApp)
        {
            strTextFieldID = "txtStartDateApp"
        }   

        return(
            <div className={cssAssignEdit.divDateMain}>
                <ComponentDateTitle Title={window.gAppUI.LBL_StartDate}/>

                <div className={cssAssignEdit.btnDate}>
                    <TextField id={strTextFieldID} 
                        type="date" value={startDate}
                        onChange={(event) => StartDateOnChangeEventHandler(event)}/>
                </div>
            </div>
        )
    } // end of RenderStartDateAreaWrapper

    /*===========================================
    summary: Render DateArea 的顯示
    remarks: 000 Tim 2021/12/20 Create
    ===========================================*/
    function RenderDateAreaWrapper()
    {
        return(
            <div className={cssAssignEdit.divDateAreaMain}>
                {RenderStartDateAreaWrapper()}

                <ComponentDateSeparator />

                {RenderDueDateAreaWrapper()}
            </div>
        )
    } // end of RenderDateAreaWrapper

    /*===========================================
    summary: Render BottomContentArea 的顯示
    remarks: 000 Tim 2021/12/20 Create
    ===========================================*/
    function RenderBottomContentAreaWrapper(StateUpdateDataTime)
    {
        if (StateUpdateDataTime > 0)
        {
            return(
                <div className={cssAssignEdit.divBottomContentArea}>
                    {RenderDateAreaWrapper()}

                    <div className={cssAssignEdit.divDateLine}/>

                    <ComponentSelectAllButton StateIsSelectAll={isSelectAll} />

                    {RenderStudentListWrapper(updateDataTime)}

                    <ComponentSubmitButton />
                </div>
            )
        }
        else
        {
            return (
                <div className={cssAssignEdit.divBottomContentArea}/>
            )
        }
    } // end of RenderBottomContentAreaWrapper

    /*===========================================
    summary: Render Message 輸入框 的顯示
    remarks: 000 Tim 2021/12/20 Create
    ===========================================*/
    function RenderMessageInputWrapper(StateUpdateDataTime)
    {
        if (StateUpdateDataTime > 0)
        {
            return(
                <>
                    <label htmlFor="textareaMessage" className={cssAssignEdit.divHidden}>
                        {window.gAppUI.LBL_Message}
                    </label>
                    <textarea className={cssAssignEdit.txtMessage}
                        value={message}
                        placeholder={window.gAppUI.LBL_AssignMessagePlaceHolder} 
                        maxLength={MAX_MESSAGE_CHARACHERS}
                        onChange={(event) => MessageChangeHandler(event)}
                    />
                </>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderMessageInputWrapper

    /*===========================================
    summary: Render TopTool 的顯示
    remarks: 000 Tim 2021/12/20 Create
    ===========================================*/
    function RenderMessageAreaWrapper()
    {
        return(
            <div className={cssAssignEdit.divMessageArea}>
                <ComponentMessageTitle />

                {RenderMessageInputWrapper(updateDataTime)}
            </div>
        )
    } // end of RenderMessageAreaWrapper

    /*===========================================
    summary: Render TopTool 的顯示
    remarks: 000 Tim 2021/12/20 Create
    ===========================================*/
    function RenderTopToolWrapper()
    {
        return (
            <>
                <ComponentBackButton />
                <ComponentTitle StateUpdateDataTime={updateDataTime}/>
            </>
        )
    } // end of RenderTopToolWrapper

    /*===========================================
    summary: Render Content 的顯示
    remarks: 000 Tim 2021/12/20 Create
    ===========================================*/
    function RenderContentWrapper()
    {
        return (
            <>
                {RenderTopToolWrapper()}

                {RenderMessageAreaWrapper()}
                
                {RenderBottomContentAreaWrapper(updateDataTime)}
            </>
        )
    } // end of RenderContentWrapper

    /*===========================================
    summary: Render 主畫面 的顯示
    remarks: 000 Tim 2021/12/20 Create
    ===========================================*/
    function RenderMainWrapper()
    {
        return (
            <>
                <div className={cssAssignEdit.divBG}>
                    {RenderContentWrapper()}
                </div>

                <LoadingMask ShowMask={showLoadingMask} Message={loadingMaskMessage} />
                <AlertWindow ShowAlert={showAlert} AlertObject={alertObject} HideAlertFuncRef={HideAlert} />
            </>
        )
    } // end of RenderMainWrapper

    // Similar to Render
    return (
        <>
            {RenderMainWrapper()}
        </>
    )
    // #endregion Render
}
export default AssignEdit